<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2023-05-23 10:54:33
 * @LastEditors: xgx
 * @LastEditTime: 2023-05-25 16:14:19
-->
<template>
    <div>
         <div class="search">
            <el-button @click="openRules"  type="primary">监测规则</el-button>
            <div>
                <a-range-picker v-model="time" format="YYYY-MM-DD HH:mm:ss"/>
                <a-select
                showArrow
                allowClear
                v-model="stations"
                style="width: 200px; margin-right: 20px;margin-left:12px"
                placeholder="评估结果"
                >
                  <a-select-option value="0">合格</a-select-option>
                  <a-select-option value="1">不合格</a-select-option>
                </a-select>
                <el-button @click="search" type="primary">查询</el-button>
            </div>
            </div>
            <coententTable
              :y="height"
              @onShowSizeChange="onShowSizeChange"
              :columns="columns"
              :pagination="pagination"
              :dataSource="dataSource"
              :loading="loading"
              :customSlot="customSlot"
              @handleSizeChange="handleSizeChange"
            >
             <template v-slot:failureRatio="scopeVal">
                <div :style="{color:scopeVal.scope.failureRatio?'#F56C6C':''}">{{scopeVal.scope.failureRatio}}</div>
            </template>
             <template v-slot:status="scopeVal">
                <div class="status-txt-one" v-if="scopeVal.scope.status == 0">合格</div>
                <div class="status-txt-two" v-if="scopeVal.scope.status == 1">不合格</div>
            </template>
              <template v-slot:operation="scopeVal">
                  <div v-if="codeData.indexOf('334') != -1" @click="openList(scopeVal.scope)" class="btnTwo">错链清单</div>
              </template>
            </coententTable>
            <DetectionRules v-if="dialogVisible" @handleClose="handleClose" :dialogVisible="dialogVisible"></DetectionRules>
            <linkList :itemData="itemData" v-if="dialogVisibleTwo" @handleClose="handleCloseTwo" :dialogVisible="dialogVisibleTwo"></linkList>
    </div>
</template>
<script>
import {urlUsabilityPageList} from '../index';
import coententTable from "@/components/coentent_table.vue";
import DetectionRules from "./detection_rules.vue";
import linkList from "./link_list.vue";
export default {
  components: {coententTable,DetectionRules,linkList},
  data() {
    return {
      height: 0,
      loading: false,
      columns: [
        {
          title: "监测日期",
          dataIndex: "time",
          width: 200,
          ellipsis: true,
        },
        {
          title: "监测链接总数",
          dataIndex: "urlCountNumber",
          width: 200,
          ellipsis: true,
        },
        {
          title: "首页错链数",
          dataIndex: "indexErrorNumber",
          width: 200,
          ellipsis: true,
        },
        {
          title: "其他页错链数",
          dataIndex: "otherPageNumber",
          width: 200,
          ellipsis: true,
        },
        {
          title: "错链占比",
          dataIndex: "errorProportion",
          width: 200,
          ellipsis: true,
        },
        {
          title: "监测站点",
          dataIndex: "siteName",
          ellipsis: true,
          customCell: (column) => {
            return {
              style: {
                "min-width": "120px",
                "max-width": "400px",
              },
            };
          },
          customHeaderCell: (column) => {
            return {
              style: {
                "min-width": "120px",
                "max-width": "400px",
              },
            };
          },
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          width: 120,
          fixed: "right",
        },
      ],
      customSlot: [
        {
          name: "status",
          customRender: "status",
        },
        {
          name: "failureRatio",
          customRender: "failureRatio",
        }
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ["10", "20", "30"],
      },
      dataSource: [],
      time: [],
      stations: undefined,
      dialogVisible:false,
      dialogVisibleTwo:false,
      itemData:{},
      codeData:[],
    };
  },

  mounted() {
    this.getList()
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
  },
  methods: {
    farmatDate(date, cut) {
      var date = new Date(date);
      var YY = date.getFullYear() + cut;
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + cut;
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
      (":");
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD;
    },
    getList() {
      this.loading = true;
      let startTime = '';
      let endTime = '';
      if(this.time.length > 0){
        startTime  = this.farmatDate(new Date(this.time[0].toString()).getTime(),'-')
        endTime = this.farmatDate(new Date(this.time[1].toString()).getTime(),'-')
      }
      urlUsabilityPageList({
        current:this.pagination.current,
        size:this.pagination.pageSize,
        endTime:endTime,
        startTime:startTime,
        status:this.stations,
        siteId:sessionStorage.getItem('siteId')
      }).then((res)=>{
              if(res.code == 0){
              this.dataSource = res.data.records;
              this.pagination.current =  res.data.current;
              this.pagination.total =  res.data.total;
              if(this.pagination.total > 0){
                this.height = document.documentElement.clientHeight - 419;
                window.onresize = () => {
                    return (() => {
                      this.height = document.documentElement.clientHeight - 419;
                    })();
                  };
              }
              this.loading = false;
          }else{
            this.loading = false;
          }
      })
    },
    search() {
       this.pagination.current = 1;
       this.getList();
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.getList();
    },
    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.current = 1;
      this.getList();
    },
    openRules(){
      this.dialogVisible = true;
    },
    handleClose(){
        this.dialogVisible = false;
    },
    handleCloseTwo(){
      console.log('ssssssss')
        this.dialogVisibleTwo = false;
    },
    openList(item){
        this.itemData = item;
        this.dialogVisibleTwo = true;
        
    }
  },
};
</script>

<style lang="less" scoped>
.search {
  padding: 0 24px 0 24px;
  justify-content: space-between;
  display: flex;
  margin-top: 20px;
  /deep/ .ant-select-selection {
    background-color: rgba(245, 247, 250, 1);
    height: 40px;
  }
  /deep/ .ant-input {
    background-color: rgba(245, 247, 250, 1);
    height: 40px;
  }
  /deep/ .el-input__inner {
    background-color: rgba(245, 247, 250, 1);
    height: 40px;
  }
  /deep/ input::-webkit-input-placeholder {
    color: rgba(102, 111, 128, 1);
  }
  /deep/ .ant-select-selection__placeholder {
    color: rgba(102, 111, 128, 1);
  }
  /deep/ .ant-select-selection__rendered {
    line-height: 39px;
  }
  /deep/ .el-select__tags {
    white-space: nowrap;
    overflow: hidden;
  }
  /deep/ .el-select__tags {
    flex-wrap: nowrap;
  }
}
/deep/ .el-tabs__header{
  margin: 0px;
}
.el-button--primary {
  background: #176de6;
}

.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 66px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.status-txt-one{
  background-color: rgba(255, 255, 255, 1);
  color: rgba(103, 194, 58, 1);
  font-size: 14px;
  text-align: left;
  font-family: Microsoft Yahei;
}
.status-txt-two{
  background-color: rgba(255, 255, 255, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 14px;
  font-family: Microsoft Yahei;
}
</style>